import { SentimentType } from '@op/types/common';
import { GptRequestType, ScenarioType } from '../types';

const sentimentMap: { [key: string]: SentimentType } = {
  negative: '1',
  neutral: '3',
  positive: '5',
};

function dealwithUrlVideoGpt(data: GptRequestType) {
  if (!data) return data;

  const report = data.report_en;

  const [summary, sentiment] = report.split('<SEP>');

  data.report_en = summary;
  data.report_zh = summary;

  return {
    report_en: summary,
    report_zh: summary,
    task_status: data.task_status,
    sentiment: sentimentMap[sentiment?.trim()] || '3',
  };
}

export const dealwithScenarioMap: {
  [key in ScenarioType]?: (data: GptRequestType) => GptRequestType;
} & { default: (data: GptRequestType) => GptRequestType } = {
  url_video_task: dealwithUrlVideoGpt,
  default: (data: GptRequestType) => data,
};
